import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SideNavigationService } from 'src/sb-tools/typescript/services/side-navigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { BaseUser } from 'src/sb-tools/typescript/models/base-user.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AdvancedSearchModalComponent } from '../shared/modal-windows/advanced-search-modal/advanced-search-modal.component';
import { ComponentMessengerService } from '../core/services/component-messenger.service';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { AuthenticationService } from 'src/sb-tools/typescript/authentication/authentication.service';
import { SettingsMenuComponent } from 'src/sb-modules/Frontend-Settings-Menu-Module/settings-menu.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGComponent } from '../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsDropdownComponent } from './notifications-dropdown/notifications-dropdown.component';
import { SettingsMenuComponent as SettingsMenuComponent_1 } from '../../sb-modules/Frontend-Settings-Menu-Module/settings-menu.component';
import { isInboxElementVisible } from '../core/utils/is-inbox-element-visible.util';
import { isInboxLeftSidebarVisible } from '../core/utils/is-inbox-left-sidebar-visible.util';

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.scss'],
    imports: [
        NgClass,
        FormsModule,
        InlineSVGComponent,
        TranslateModule,
        NotificationsDropdownComponent,
        SettingsMenuComponent_1,
    ],
})
export class TopMenuComponent implements OnInit, OnDestroy {
    @ViewChild(SettingsMenuComponent) private settingsMenuComponent: SettingsMenuComponent;

    @Input() searchQuery: string;

    searchQueryUpdate = new Subject<string>();
    user: BaseUser;

    private previousSearchQuery;
    private unsubscriber = new Subject<void>();

    constructor(
        public authenticationService: AuthenticationService,
        public sideNavigationService: SideNavigationService,
        public commonDataService: CommonDataService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private componentMessengerService: ComponentMessengerService,
        private bsModalService: BsModalService,
    ) {}

    ngOnInit() {
        this.commonDataService.searchQuery = this.activatedRoute.snapshot.queryParams['query'];
        this.previousSearchQuery = this.commonDataService.searchQuery;

        this.user = this.commonDataService.user;

        this.searchQueryUpdate.pipe(debounceTime(700), takeUntil(this.unsubscriber)).subscribe(() => {
            this.startTextSearch();
        });
    }

    cleanSearch() {
        this.commonDataService.searchQuery = '';
        this.searchQueryUpdate.next('');
    }

    openAdvancedSearchModal() {
        const initialState = {};

        this.bsModalService.show(AdvancedSearchModalComponent, {
            initialState,
            ignoreBackdropClick: true,
        });
    }

    isLeftSidebarVisible(): boolean {
        return isInboxLeftSidebarVisible(
            this.commonDataService.user,
            this.commonDataService.customerSettings,
            this.commonDataService.hasVisibleLeftMenuFilters,
        );
    }

    isTopBarVisible(key: 'searchField' | 'notificationBell'): boolean {
        return isInboxElementVisible(this.commonDataService.customerSettings?.inboxElementsVisibility?.topBar?.[key]);
    }

    startTextSearch(): void {
        if (!this.previousSearchQuery && !this.commonDataService.searchQuery) {
            return;
        }

        this.previousSearchQuery = this.commonDataService.searchQuery;

        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { query: this.commonDataService.searchQuery },
        });
    }

    toggleSidebar(): void {
        this.sideNavigationService.toggleSidebar();
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
